import { useToaster } from './toaster'

export default function (data: any) {
  const toaster = useToaster()
  const nuxtApp = useNuxtApp()

  const keys = Object.keys(data?.errors || {})
  if (keys.length > 0) {
    toaster.show({
      title: nuxtApp.$i18n.t('error'),
      message: data.errors[keys[0]][0],
      color: 'danger',
      icon: 'lucide:alert-triangle',
      closable: true,
    })
    return
  } else if (data?.message) {
    toaster.show({
      title: nuxtApp.$i18n.t('error'),
      message: data.message,
      color: 'danger',
      icon: 'lucide:alert-triangle',
      closable: true,
    })
    return
  }
  toaster.show({
    title: nuxtApp.$i18n.t('error'),
    message: nuxtApp.$i18n.t('errors.something_went_wrong'),
    color: 'danger',
    icon: 'lucide:alert-triangle',
    closable: true,
  })
}
